import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import FileUploadField from "../../../components/Fields/FileUploadField";
import SelectListField from "../../../components/Fields/SelectListField";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import SpinnerOverlay from "../../../components/Spinner/SpinnerOverlay";
import { useNotifications } from "../../../contexts/notificationContext";
import AttachmentTypeModel from "../../../models/AttachmentTypeModel";
import ItemAttachmentCreateModel from "../../../models/ItemAttachmentCreateModel";
import ItemAttachmentModel from "../../../models/ItemAttachmentModel";
import ItemRevisionModel from "../../../models/ItemRevisionModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface IProps extends PopupProps{
    itemRevision: ItemRevisionModel
    itemAttachments: ItemAttachmentModel[]
}
const AddItemAttachmentPopup: React.FC<IProps> = ({ show, onHide, itemRevision, itemAttachments }) => {
    const [files, setFiles] = useState<File[]>();
    const [attachmentType, setAttachmentType] = useState<AttachmentTypeModel>()
    const [showSpinner, setShowSpinner] = useState(false);
    const [serverErrors, setServerErrors] = useState<DataResult<ItemAttachmentCreateModel>>({ isSuccesful: true, messages: [], data: undefined });
    const attachmentTypes = useSelectListOptions('api/v1/selectlist/AttachmentTypesForItemType?itemTypeId=' + itemRevision.item.itemTypeId, '-- Select attachment type');

    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<ItemAttachmentCreateModel>({
        itemId: itemRevision.itemId,
        itemRevisionId: itemRevision.id,
        attachmentTypeId: 0,
    });

    useEffect(() => {
        if (formData.attachmentTypeId) {
            DataService.getById<AttachmentTypeModel>('api/v1/AttachmentTypes/', formData.attachmentTypeId)
                .then(response => {
                    setAttachmentType(response)
                    setFormData(x => { return { ...x, attachmentName: getAttachmentName(response) } })
                })

                .catch(e => { handleException(e) })
        }
    }, [formData.attachmentTypeId])

    function getAttachmentName(attachmentType: AttachmentTypeModel) {
        if (!attachmentType.abbreviation)
            return ''

        var count = itemAttachments.filter(x => x.attachment.attachmentTypeId == formData.attachmentTypeId).length
        if (count + 1 < 10)
            return `${attachmentType.abbreviation ?? ''}_${itemRevision.item.itemNr}_0${count + 1}`
        else
            return `${attachmentType.abbreviation ?? ''}_${itemRevision.item.itemNr}_${count + 1}`
    }


    function submit() {
        if (formData && files) {
            var count = itemAttachments.filter(x => x.attachment.attachmentTypeId == formData.attachmentTypeId).length
            for (let i = 0; i < files.length; i++) {
                let file = files[i]
                setShowSpinner(true)
                DataService.createFile(file)
                    .then(fileResponse => {
                        handleResult(fileResponse);
                        if (fileResponse.isSuccesful === true && fileResponse.data) {
                            count += 1;
                            attachmentName = file.name
                            if (attachmentType?.abbreviation) {
                                var attachmentName = count < 10
                                    ? `${attachmentType.abbreviation}_${itemRevision.item.itemNr}_0${count}`
                                    : `${attachmentType.abbreviation}_${itemRevision.item.itemNr}_${count}`
                            }
                            formData.fileResult = fileResponse.data;
                            formData.fileName = file.name;
                            formData.attachmentName = attachmentName;

                            DataService
                                .create<ItemAttachmentCreateModel>(`api/v1/ItemAttachments`, formData)
                                .then(response => {
                                    setShowSpinner(false)
                                    handleResult(response);
                                    setServerErrors(response);
                                    if (i === files.length - 1 && response.isSuccesful === true) {
                                        onHide();
                                    }
                                })
                                .catch(e => {
                                    setShowSpinner(false)
                                    handleException(e)
                                });
                        }
                        else {
                            setShowSpinner(false)
                            handleResult(fileResponse)
                        }
                    })
                    .catch(e => {
                        setShowSpinner(false)
                        handleException(e)
                    });
            }
        }
    }

    function onFieldChanged(name: string, value: string | File[]): void {
        if (name === 'fileName' && typeof (value) === 'object') {
            setFiles(value);
            if (!formData.attachmentName)
                formData.attachmentName = value[0].name;
        }
        else {
            formData[name] = value;
        }
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'attachmentTypeId', label: 'Type', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'attachmentName', label: 'Attachment name', labelSize: 3 },
            { name: 'fileName', label: 'File', labelSize: 3 },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <>
            <Popup show={show} onHide={onHide} size={'lg'} title={'Add attachment'} >
                <Popup.Body>
                    <SelectListField {...getFieldProps('attachmentTypeId')} options={attachmentTypes} />
                    <TextboxField {...getFieldProps('attachmentName')} disabled />
                    <FileUploadField {...getFieldProps('fileName')} multiple={true} />
                </Popup.Body>
                <Popup.Footer>
                    <SaveButton {...getSubmitButtonProps()} text='Add' />
                </Popup.Footer>
            </Popup>
            {showSpinner && <SpinnerOverlay />}
        </>
    );
}
export default AddItemAttachmentPopup;